export default __webpack_public_path__ + "95f80740261d9a32a2641cec1237679e.jpg";